import { gql } from '@apollo/client';
import { queryCareLevelData, queryResidentHeaderFlags } from './query/residentHeader';

type Name = {
  firstFull: string;
  gender?: string;
  last?: string;
};

export type NursingHomeHeadPropType = {
  id: string;
  name: string;
  residents: ResidentHeadPropType[];
};

export type ResidentHeadPropType = {
  id: string;
  name: Name;
  bed?: {
    label?: string;
  };
  profilePictureUrl?: string | null;
};

export const GET_RESIDENT_CARE_LEVEL = gql`
  query getResidentCareLevel($residentId: ID!) {
    getResidentContractByResidentId(residentId: $residentId) {
      ${queryCareLevelData}
    }
  }
`;

export const GET_RESIDENT_HEADER_FLAGS = gql`
  query getResidentHeaderFlags($residentId: String!) {
    getResidentHeaderFlags(residentId: $residentId) {
      ${queryResidentHeaderFlags}
    }
    getResident(id: $residentId) {
      isAbsent
    }
  }
`;
